import { render } from "./Button.vue?vue&type=template&id=81e8716c"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
script.render = render

export default script